import { ContactFinanceType, LoadingStatusType } from "@/enums/enums";
import { ConvertToContactList, ConvertToContactSearchFirst } from "@/service/contact/contactFacade";
import service from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Contact extends VuexModule {
  public autoCompleteContactListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public autoCompleteContactList: any = [];
  public autoCompleteContactListDefault: any = [];
  public autoCompleteContactFinanceTypeDefault = ContactFinanceType.All;
  public autoCompleteContactListSequenceNumber = 0;
  public autoCompleteContactListSearchText = "";
  public contactModelList: any = [];
  public contactModelListLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getAutoCompleteContactList() {
    return this.autoCompleteContactList;
  }

  get getAutoCompleteContactListLoadingStatus() {
    return this.autoCompleteContactListLoadingStatus;
  }

  get getAutoCompleteContactListSequenceNumber() {
    return this.autoCompleteContactListSequenceNumber;
  }

  get getAutoCompleteContactListSearchText() {
    return this.autoCompleteContactListSearchText;
  }

  get getContactModelList() {
    return this.contactModelList;
  }

  get getContactModelListLoadingStatus() {
    return this.contactModelListLoadingStatus;
  }

  @Mutation
  public MutationAutoCompleteContactListSequenceNumber(_sequenceNumber: number) {
    this.autoCompleteContactListSequenceNumber = _sequenceNumber;
  }

  @Mutation
  public MutationAutoCompleteContactListSearchText(_searchText: string) {
    this.autoCompleteContactListSearchText = _searchText;
  }

  @Mutation
  MutationAutoCompleteContactListDefault(_contactList: any) {
    this.autoCompleteContactListDefault = _contactList;
  }

  @Mutation
  MutationAutoCompleteContactFinanceTypeDefault(_contactList: any) {
    this.autoCompleteContactFinanceTypeDefault = _contactList;
  }

  @Mutation
  public MutationSetAutoCompleteContactListLoadingStatus(status: LoadingStatusType) {
    this.autoCompleteContactListLoadingStatus = status;
  }

  @Mutation
  public MutationAutoCompleteContactList(_contactList: any) {
    this.autoCompleteContactList = _contactList;
  }

  @Mutation
  public MutationSetContactModelListLoadingStatus(status: LoadingStatusType) {
    this.contactModelListLoadingStatus = status;
  }

  @Mutation
  public MutationContactModelList(_contactModelList: any) {
    this.contactModelList = [...this.contactModelList, ..._contactModelList];
  }

  @Action
  public DoGetContactSearchFirst(input: any) {
    if (this.autoCompleteContactListLoadingStatus !== LoadingStatusType.Loading) {
      const searchText = input.searchText ? input.searchText.trim() : input.searchText;
      this.context.commit("MutationAutoCompleteContactListSequenceNumber", input.sequenceNumber);
      this.context.commit("MutationAutoCompleteContactListSearchText", input.searchText);
      this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Loading);
      let isLoadContactList = true;
      if (searchText == "") {
        const contactListDefault = this.autoCompleteContactListDefault;
        const contactFinanceTypeDefault = this.autoCompleteContactFinanceTypeDefault;
        if (
          contactListDefault &&
          contactListDefault.length > 0 &&
          contactFinanceTypeDefault == input.contactFinanceType
        ) {
          this.context.commit("MutationAutoCompleteContactList", contactListDefault);
          isLoadContactList = false;
          setTimeout(() => {
            this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Success);
          }, 250);
        }
      }
      if (isLoadContactList) {
        service.ContactService.DoGetContactSearchFirst(input.contactFinanceType).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const contactList = ConvertToContactSearchFirst(res.data.contactSearchList);
            this.context.commit("MutationAutoCompleteContactListDefault", contactList);
            this.context.commit("MutationAutoCompleteContactFinanceTypeDefault", input.contactFinanceType);
            this.context.commit("MutationAutoCompleteContactList", contactList);
          }
          this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Success);
        });
      }
    }
  }

  @Action
  public DoGetContactSearchWithSearchText(input: any) {
    if (this.autoCompleteContactListLoadingStatus !== LoadingStatusType.Loading) {
      const searchText = input.searchText ? input.searchText.trim() : input.searchText;
      this.context.commit("MutationAutoCompleteContactListSequenceNumber", input.sequenceNumber);
      this.context.commit("MutationAutoCompleteContactListSearchText", input.searchText);
      this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Loading);
      let isLoadContactList = true;
      if (searchText == "") {
        const contactListDefault = this.autoCompleteContactListDefault;
        const contactFinanceTypeDefault = this.autoCompleteContactFinanceTypeDefault;
        if (
          contactListDefault &&
          contactListDefault.length > 0 &&
          contactFinanceTypeDefault === input.contactFinanceType
        ) {
          this.context.commit("MutationAutoCompleteContactList", contactListDefault);
          isLoadContactList = false;
          setTimeout(() => {
            this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Success);
          }, 250);
        }
      }
      if (isLoadContactList) {
        service.ContactService.DoGetContactSearchWithSearchText(searchText, input.contactFinanceType).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const contactList = ConvertToContactSearchFirst(res.data.contactSearchList);
            this.context.commit("MutationAutoCompleteContactList", contactList);
          }
          this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Success);
        });
      }
    }
  }

  @Action
  public DoGetContactByContactIdList(contactIdList: Array<number>) {
    return new Promise((resolve) => {
      if (this.contactModelListLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Loading);
        contactIdList = [...new Set(contactIdList)];
        let contactIdForSearch = [] as Array<number>;
        if (this.contactModelList && this.contactModelList.length > 0) {
          contactIdList.forEach((contactId) => {
            const contactOnLocal = this.contactModelList.find((x: any) => x.id === contactId);
            if (!contactOnLocal) {
              contactIdForSearch.push(contactId);
            }
          });
        } else {
          contactIdForSearch = contactIdList;
        }

        if (contactIdForSearch.length > 0) {
          service.ContactService.DoGetContactByContactIdList(contactIdForSearch).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const contactModelList = ConvertToContactList(res.data.contactList);
              this.context.commit("MutationContactModelList", contactModelList);
            }
            this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Success);
            resolve("resolved");
          });
        } else {
          setTimeout(() => {
            this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Success);
            resolve("resolved");
          }, 250);
        }
      }
    });
  }

  @Action
  public DoGetContactByContactIdListAsync(contactIdList: Array<number>): Promise<void> {
    return new Promise((resolve) => {
      contactIdList = [...new Set(contactIdList)];
      let contactIdForSearch = [] as Array<number>;
      if (this.contactModelList && this.contactModelList.length > 0) {
        contactIdList.forEach((contactId) => {
          const contactOnLocal = this.contactModelList.find((x: any) => x.id === contactId);
          if (!contactOnLocal) {
            contactIdForSearch.push(contactId);
          }
        });
      } else {
        contactIdForSearch = contactIdList;
      }

      if (contactIdForSearch.length > 0) {
        service.ContactService.DoGetContactByContactIdList(contactIdForSearch).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const contactModelList = ConvertToContactList(res.data.contactList);
            this.context.commit("MutationContactModelList", contactModelList);
          }
          resolve();
        });
      } else {
        setTimeout(() => {
          resolve();
        }, 250);
      }
    });
  }
}
